import styled from 'styled-components'

export const Table = styled.table`
  display: block;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-spacing: 0;

  & thead,
  tbody {
    display: block;
    width: 100%;
  }
`
